import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { AddressModel } from './address.model';
import { ContactService } from '@fi-shared/fi-contacts/contact.service';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { debounce, takeUntil } from 'rxjs/operators';
import { interval, Subject } from 'rxjs';
import { FiBrowserEventsService } from '@fi-shared/fi-shared-services/fi-browser-events.service';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';

@Component({
    selector: 'fi-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-address' },
    providers: [{ provide: FiComponentsContainer, useExisting: AddressComponent }],
    standalone: false,
})
export class AddressComponent extends FiComponentsContainer implements OnInit, OnDestroy {
    @Input() address: AddressModel;
    @Input() required: boolean;
    @Input() isDefaultAddress: boolean;
    @Input() isEditDeleteDisabled: boolean;
    @Input() isMultipleAddresses: boolean = true;
    @Output() onAddNewContact: EventEmitter<void> = new EventEmitter<void>();
    @Output() onDeleteContact: EventEmitter<void> = new EventEmitter<void>();
    @Input() addOffsetToWideInput: boolean = true;
    @Input() isNewAddButtonLayout: boolean;

    constructor(
        private contactService: ContactService,
        private fiBrowserEventsService: FiBrowserEventsService,
        private cdr: ChangeDetectorRef,
        private detectDevicesService: DetectDevicesService,
    ) {
        super();
    }

    ngOnInit() {
        this.subscribeOnResize();
    }

    private subscribeOnResize() {
        this.fiBrowserEventsService
            .getWindowEventSubject$('resize')
            .pipe(
                debounce(() => interval(200)),
                takeUntil(this.ngOnDestroy$),
            )
            .subscribe(() => this.cdr.markForCheck());
    }

    isRequired(): boolean {
        // https://chainformation.atlassian.net/browse/FI-4632
        return this.required;
        /*return this.required
            || (isDefined(this.address.Street) && this.address.Street.length > 0)
            || (isDefined(this.address.ZipCode) && this.address.ZipCode.length > 0)
            || (isDefined(this.address.City) && this.address.City.length > 0)
            || (isDefined(this.address.Country) && this.address.Country.length > 0)
            || (isDefined(this.address.StreetExtra) && this.address.StreetExtra.length > 0);*/
    }

    isDisabled(): boolean {
        return this.contactService.isAddressImported(this.address.AddressType);
    }

    isMobileSmall(): boolean {
        return this.detectDevicesService.isMobileSmall();
    }

    addNewAddress() {
        this.onAddNewContact.emit();
    }

    removeAddress() {
        this.onDeleteContact.emit();
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
